export default __webpack_public_path__ + "static/media/30days-calender-mobile.af42c86d.png";